import MessageView, { DispatchFromProps, StateFromProps } from './MessageView';
import { attemptPostMessage, openModal } from '../appActions';

import { ModalWrapperProps } from '../Modal/ModalWrapper';
import { Store } from '../rootReducer';
import { ThunkDispatch } from '../types';
import { connect } from 'react-redux';

const mapStateToProps = (store: Store): StateFromProps => ({
  dayMessageMap: store.appReducer.dayMessageMap,
  userId: store.loginReducer.userId,
  teamId: store.listViewReducer.currentTeam,
  employees:
    store.listViewReducer.employeeMap[store.listViewReducer.currentTeam] ?? {},
  currentDate: store.appReducer.globalSettings.useDateTime,
  period: store.listViewReducer.period,
  activeScope: store.appReducer.settings.activeScope,
  canSeeConfidentialInfo: store.appReducer.userSettings.canSeeConfidentialInfo,
});

const mapDispatchToProps = (dispatch: ThunkDispatch): DispatchFromProps => ({
  openModal: (modal: ModalWrapperProps) => {
    dispatch(openModal(modal));
  },
  callPostMessage: (personId, messageText, isInternal, date, sentWhen) => {
    void dispatch(
      attemptPostMessage(personId, messageText, isInternal, date, sentWhen)
    );
  },
});

export default connect<StateFromProps, DispatchFromProps, object, Store>(
  mapStateToProps,
  mapDispatchToProps
)(MessageView);
